import controller from './controller';
import template from './template.html';
import styles from './styles.less';

routes.$inject = ['$stateProvider', '$urlRouterProvider'];

export default function routes($stateProvider){

	$stateProvider.state('createAccount', {
		url: '/createAccount?accessKey',
		controllerAs: 'ctrl',
		controller: controller,
		template: template
	})
}


/** WEBPACK FOOTER **
 ** ./src/guest/createAccount/routes.js
 **/